import type { SalesDemoStatus } from '@/lib/api/api.gen'

const provisioningStatuses = new Set<SalesDemoStatus>(['pending', 'provisioning'])

/** Reads a full demo or the organization payload's `sales_demo` summary. */
export function isSalesDemoProvisioning(
  salesDemo: { status: SalesDemoStatus } | null | undefined
): boolean {
  return salesDemo !== null && salesDemo !== undefined && provisioningStatuses.has(salesDemo.status)
}
